package com.neurobs.react.semanticui

import com.neurobs.react.{ReactUtil, StyleUtil}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html._

object UiLoaderFactory {

  private def TemplateLoader(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("loader"),
      style := uiElementModifiers.createStyle
    )()
  }

  private def TemplateTextLoader(text: String)(uiElementModifiers: UiElementModifiers) = {
    div(
      className := uiElementModifiers.formattedClassName("loader"),
      style := uiElementModifiers.createStyle
    )(
      text
    )
  }

  def ActiveTextLoader(text: String)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateTextLoader(text)("active text " + uiElementModifiers.elementModifiers, uiElementModifiers.classString, uiElementModifiers.styleAttributes)
  }
}


